import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { StoreStockAvailability } from '../utils/storeStockAvailability/storeStockAvailability.js';
const StoreAvailabilityContext = createContext(undefined);
export const StoreAvailabilityProvider = ({ children, store, stockLocationId, availabilityState, productId, onlineAvailabilityState, expectedReleaseDate, isSelected, setSelected, timeTravelOverride, trackSelectedStore, }) => {
    const schedules = store.schedules || [];
    const getDateIndex = (date) => {
        const currentDay = date.getDay();
        return currentDay === 0 ? 6 : currentDay - 1;
    };
    const now = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    const dateIndex = getDateIndex(now);
    const weeklyOpeningHours = schedules.slice(dateIndex, dateIndex + 7);
    const isAvailableOnline = StoreStockAvailability.isOnStock(onlineAvailabilityState);
    const isPreOrderOnline = StoreStockAvailability.isPreOrder(onlineAvailabilityState);
    const isPreOrderInStore = StoreStockAvailability.isPreOrder(availabilityState);
    const isPreOrder = isPreOrderInStore || isPreOrderOnline;
    const isAddToCartButtonVisible = isSelected && (isAvailableOnline || isPreOrder);
    return (_jsx(StoreAvailabilityContext.Provider, { value: {
            store,
            weeklyOpeningHours,
            stockLocationId,
            availabilityState,
            productId,
            isPreOrder,
            expectedReleaseDate,
            isSelected,
            isAddToCartButtonVisible,
            setSelected,
            timeTravelOverride,
            trackSelectedStore,
        }, children: children }));
};
export const useStoreAvailability = () => {
    const context = useContext(StoreAvailabilityContext);
    if (!context) {
        throw new Error('useStoreAvailability must be used within a StoreAvailabilityProvider');
    }
    return context;
};
//# sourceMappingURL=StoreAvailabilityContext.js.map